export enum BuilderArea {
  properties = 'properties',
  relationships = 'relationships',
  actions = 'actions',
  triggers = 'triggers',
  permissions = 'permissions',
  permissionsActions = 'permissionsActions',
  permissionsProperties = 'permissionsProperties',
  permissionsRelationships = 'permissionsRelationships',
  settings = 'settings',
  experimental = 'experimental'
}
